module.exports = __webpack_public_path__ + "static/media/accessories-7.ee363b4c.jpg";